import type { AccessRole } from '@gat-ship/types'
import type { ComboboxFieldItem } from '@gat-ship/vue-components'

/**
 * Functional core — build the combobox option list for an access-role picker.
 *
 * Pure: maps roles to options, appends the pre-selected role when it is not
 * already present, and sorts by title (A→Z). Never mutates its inputs. The
 * `ComboboxFieldItem` import is type-only, so `model/` stays runtime-free.
 */

function toOption(role: AccessRole): ComboboxFieldItem<AccessRole> {
  return {
    title: role.name,
    value: role.id,
    searchValue: `${role.name}`,
    metaData: role
  }
}

export function buildAccessRoleOptions(
  roles: readonly AccessRole[],
  preSelectedAccessRole?: AccessRole
): ComboboxFieldItem<AccessRole>[] {
  const options = roles.map(toOption)
  if (
    preSelectedAccessRole &&
    !options.find((option) => option.value === preSelectedAccessRole.id)
  ) {
    options.push(toOption(preSelectedAccessRole))
  }
  return options.sort((a, b) => a.title.localeCompare(b.title))
}
